module.exports = __webpack_public_path__ + "img/youtube-update.bd6cc079.svg";